import React from 'react'
import { Link } from 'react-router-dom'

function FixtureEventTable({events}) {
    return (
        <div className="row">
            <table>
                <tbody style={{fontSize: "12px"}}>
                    {events.map((event, index) => {
                        return (
                            <tr key={index} className="bg-white p-1">
                                <td>
                                    {event.type === "Goal" && <i className="far fa-futbol"></i>}
                                    {event.type === "Card" && <img style={{maxWidth: "20px"}} className="img-fluid" src={event.detail === "Yellow Card" || !event.detail ? "https://progitek.no/privat/bp/wp-content/uploads/2020/07/yellow-card-1911102-1613794.png" : "https://progitek.no/privat/bp/wp-content/uploads/2020/07/last-ned.png"} />}
                                    {event.type === "subst" && <img style={{maxWidth: "20px"}} className="img-fluid" src="https://progitek.no/privat/bp/wp-content/uploads/2020/07/1200px-Substitution.svg_.png" />}
                                </td>
                                <td>
                                    {event.teamName}
                                </td>
                                <td>
                                    {event.type === "subst" && <>   <i className="fas fa-arrow-circle-down text-danger"></i> {event.detail}   <i className="fas fa-arrow-circle-up text-success"></i>  </>}
                                    {event.player} 
                                    {event.assist && event.type === "Goal" && 
                                        <span>
                                            <img className="img-fluid ml-2" src="https://progitek.no/privat/bp/wp-content/uploads/2020/07/a-icon-28.png" style={{maxWidth: "20px"}} /> {event.assist}
                                        </span>
                                    
                                    }
                                    <span>{event.type === "Card" && ` ${event.detail}`} <Link to={`/players-api/${event.player_id}`}>{event.comments}</Link></span>
                                </td>
                                <td>
                                    {event.elapsed}{event.elapsed_plus && `+${event.elapsed_plus}`}'
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}
export default FixtureEventTable